/* eslint-disable no-nested-ternary */
import { Affix, Box, Button, Flex, Progress, Skeleton, Text, Transition, useMantineTheme } from '@mantine/core';
import { useVendorAvailability } from '@services/availabilitytime/hooks/useVendorAvailability';
import { RootState } from '@stores/index';
import { IconShoppingCart } from '@tabler/icons-react';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FormattedPrice } from '../../../../components/common/data-display/price';
import useCartCombinedPrice from '../../shared/hooks/useCartCombinedPrice';

const CartAffix = ({
  minimumBasket = 0,
  isQuickOrder,
}: {
  minimumBasket: number | undefined;
  isQuickOrder: boolean;
}) => {
  const { combinedTotalPrice } = useCartCombinedPrice();
  const { items } = useSelector((state: RootState) => state.cart);
  const [loadingPage, setLoadingPage] = useState(false);
  const { data, isLoading: loading, isFetching } = useVendorAvailability();

  const router = useRouter();
  useEffect(() => {
    const handleStart = (url: string) => url !== router.asPath && setLoadingPage(true);
    const handleComplete = (url: string) => url === router.asPath && setLoadingPage(false);

    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleComplete);
    router.events.on('routeChangeError', handleComplete);

    return () => {
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleComplete);
      router.events.off('routeChangeError', handleComplete);
    };
  });

  const isMinBasketReached = combinedTotalPrice >= minimumBasket;

  const theme = useMantineTheme();

  const button = data?.data?.isVendorOpen ? (
    <Flex align="center" wrap="nowrap" gap="xs">
      <Button
        id="to_basket"
        onClick={() => router.push({ pathname: isQuickOrder ? '/quick' : '/cart', query: { ...router.query } })}
        disabled={loading || loadingPage}
        loading={loading || loadingPage}
        size="md"
        leftSection={<IconShoppingCart size="1rem" />}
      >
        ادامه خرید
      </Button>
      <Box pr="xl">
        <FormattedPrice price={combinedTotalPrice} />
      </Box>
    </Flex>
  ) : (
    <Button size="sm" color="red" loading={loading}>
      مجموعه بسته است
    </Button>
  );

  const output = isMinBasketReached ? (
    !loading && !isFetching ? (
      button
    ) : (
      <Skeleton w={80} h={40} />
    )
  ) : (
    <>
      <Text p="xs" ta="center">
        حداقل خرید {minimumBasket} تومان است.
      </Text>

      <Progress
        value={(100 * combinedTotalPrice) / minimumBasket}
        radius={0}
        size="lg"
        style={{ borderBottomRightRadius: theme.radius.md, borderBottomLeftRadius: theme.radius.md }}
      />
    </>
  );

  return (
    <Affix zIndex={199} style={{ left: '50%', transform: 'translate(-50%, -50%)' }}>
      <Transition transition="slide-up" mounted={items.length > 0}>
        {(transitionStyles) => (
          <Box
            style={{
              backgroundColor: theme.white,
              borderRadius: theme.radius.md,
              padding: '4px',
              boxShadow: theme.shadows.xl,
              ...transitionStyles,
            }}
          >
            {output}
          </Box>
        )}
      </Transition>
    </Affix>
  );
};

export default CartAffix;
